import {Discount, OrderItem, ViewOrder, viewOrder} from './OrderState'

export type Order = {
  id: string
  orderEditId: string | any
  orderDeliveryMethod: string
  subtotalPrice: number | any
  shippingPrice: number | any
  totalDiscounts: number | any
  wineClubDiscounts: number | any
  totalTax: number | any
  totalPrice: number | any
  wineClubDiscountCodeId: string | any
  discountCodeId: string | any
  freeShippingDiscountCodeId: string | any
  note: string | any
  orderItems: OrderItem[]
  salesTax: number | any
  crv: number | any
  orderNumber?: number
  tipAmount?: number | any
}

type RefundCustomer = {
  isCustomerNotify: boolean
  refundPrice: number | any
  maxRefundPrice: number | any
  maxShippingRefundFee: number | any
  orderRefundPrice: number | any
  shippingRefundPrice: number | any
  isValidateDiscount: boolean
  freightSalesTax: number | any
  salesTax: number | any
  discounts: any[]
  removeDiscountIds: any[]
}

export type RefundOrder = Order & RefundCustomer

export type PosTerminalOrderRefund = {
  amount: number
  result: any
}

export type RefundOrderState = {
  viewOrder: ViewOrder
  refund: RefundOrder
  isFetching: boolean
  isRefundAll: boolean
  restockLocationId: string | null
  isRestock: boolean
  isDirty: boolean
  deletedItems: any[]
  discounts: Discount | any
  isValidatingDiscount: boolean
  errors: []
  orderProcessErrors: []
}

export const order: Order = {
  id: '',
  orderDeliveryMethod: '',
  subtotalPrice: '',
  shippingPrice: '',
  totalDiscounts: '',
  wineClubDiscounts: '',
  totalTax: '',
  orderEditId: null,
  wineClubDiscountCodeId: '',
  freeShippingDiscountCodeId: '',
  discountCodeId: '',
  note: '',
  totalPrice: '',
  orderItems: [],
  salesTax: 0,
  crv: 0,
  tipAmount: 0,
}

export const refund: RefundOrder = {
  ...order,
  orderItems: [],
  isCustomerNotify: false,
  maxRefundPrice: '',
  refundPrice: '',
  isValidateDiscount: false,
  maxShippingRefundFee: 0,
  freightSalesTax: 0,
  salesTax: 0,
  orderRefundPrice: 0,
  shippingRefundPrice: 0,
  discounts: [],
  removeDiscountIds: [],
}

export const orderInitialState: RefundOrderState = {
  viewOrder,
  refund,
  isRefundAll: false,
  isFetching: false,
  isDirty: false,
  deletedItems: [],
  discounts: {},
  isValidatingDiscount: false,
  errors: [],
  orderProcessErrors: [],
  restockLocationId: null,
  isRestock: false,
}
